import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Riders from './Riders';
import Drivers from './Drivers';
import Lideres from './Lideres';
import FleetAdmins from './FleetAdmins';
import CreateAdmin from './CreateAdmin';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import { c2PillTabsSx as tabsSx } from '../components/Table/C2UserTable';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Users() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const auth = useSelector(state => state.auth);
  const [role, setRole] = React.useState(null);

  React.useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const handleChange = (event, newValue) => {
    navigate(`/users/${newValue}`)
  };

  React.useEffect(()=>{
    if(id && typeof(Number(id)) === "number" && Number(id)>=0 && Number(id) <=4){
      setValue(Number(id));
    }else{
      navigate("/404");
    }
  },[id,navigate])

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={value} onChange={handleChange} aria-label="Tipos de usuario" sx={tabsSx} variant="scrollable" scrollButtons="auto">
        <Tab icon={<PersonOutlineIcon fontSize="small" />} iconPosition="start" label={t('riders')} {...a11yProps(0)} />
        <Tab icon={<DirectionsCarOutlinedIcon fontSize="small" />} iconPosition="start" label={t('drivers')} {...a11yProps(1)} />
        <Tab icon={<HubOutlinedIcon fontSize="small" />} iconPosition="start" label="Líderes" {...a11yProps(2)} />
        {role === 'fleetadmin'?
          null : <Tab icon={<BusinessCenterOutlinedIcon fontSize="small" />} iconPosition="start" label={t('fleetadmins')} {...a11yProps(3)} />
        }
        {role === 'fleetadmin'?
          null : <Tab icon={<AdminPanelSettingsOutlinedIcon fontSize="small" />} iconPosition="start" label={t('alladmin')} {...a11yProps(4)} />
        }
      </Tabs>
      <TabPanel value={value} index={0}>
        <Riders/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Drivers/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Lideres/>
      </TabPanel>
        <TabPanel value={value} index={3}>
          <FleetAdmins/>
        </TabPanel>
        <TabPanel value={value} index={4}>
          <CreateAdmin/>
        </TabPanel>
    </Box>
  );
}
